import { render, staticRenderFns } from "./landmarkVrVideo.vue?vue&type=template&id=53ba4f82&scoped=true&"
import script from "./landmarkVrVideo.vue?vue&type=script&lang=ts&"
export * from "./landmarkVrVideo.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkVrVideo.vue?vue&type=style&index=0&id=53ba4f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba4f82",
  null
  
)

export default component.exports